import { EmptyState } from "@/components/EmptyState/EmptyState";
import { EmptyTemplatesSvg } from "@/components/Icon/Icon";
import { useTranslation } from "react-i18next";

export const NoTemplates = () => {
  const { t } = useTranslation("template");
  return <EmptyState title={t("message.noTemplates")} message={t("message.noTemplatesInfo")} image={<EmptyTemplatesSvg />} />;
};
